export const ALERT_DURATION = 5000;
export const ALERT_FADE_DURATION = 300;
